<template lang="pug">
  div.spinner-background
    div.spinner-container
      h1 {{text}}
      span#new-spinner
</template>

<script>
import _ from 'lodash'
export default {
  name: 'spinner',
  props: {
    textKey: { type: String, default: undefined }
  },
  computed: {
    text () {
      let computedKey = _.isUndefined(this.textKey) || _.isNull(this.textKey)
        ? 'spinner.loading'
        : this.textKey

      let translateText = this.$i18n.t(computedKey)
      return translateText
    }
  }
}
</script>